/**
 * 商业化页面「一个值怎么显示、一个状态什么颜色」的唯一一家。
 * 用户详情页里的订单和流水也从这里取色，两边不会各自演化出两套状态色。
 */

/** 积分商品和订单只有美元；`currency` 由后端给，大小写不做假设。 */
export function formatCurrency(cents, currency) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency.toUpperCase() }).format(cents / 100)
}

/** 变动量带符号：流水表里一列全是数字时，正负要一眼分得出来。 */
export function formatSignedPoints(amount) {
  const text = Math.abs(amount).toLocaleString('en-US')
  return amount > 0 ? `+${text}` : amount < 0 ? `-${text}` : text
}

/** 一个积分包能玩几回合：产品文档里「折合回合」这一列，运营定价时看的就是它。 */
export function turnsCoveredBy(points, turnPrice) {
  return Math.floor(points / turnPrice)
}

export function orderStatusVariant(status) {
  switch (status) {
    case 'paid':
      return 'success'
    case 'pending':
      return 'warning'
    case 'canceled':
    case 'failed':
    case 'refunded':
      return 'neutral'
    case 'disputed':
      return 'danger'
    default:
      throw new Error(`Unhandled order status: ${status}`)
  }
}

export function ledgerTypeVariant(type) {
  switch (type) {
    case 'grant':
      return 'success'
    case 'deduct':
      return 'neutral'
    default:
      throw new Error(`Unhandled ledger type: ${type}`)
  }
}

/** 到手时间用 `<input type="datetime-local">` 的本地时间，接口要 ISO；空串表示没填。 */
export function localDateTimeToIso(value) {
  return value === '' ? null : new Date(value).toISOString()
}

/** 反向：接口或深链里的 ISO 时刻 → `datetime-local` 输入框认的本地时间字符串；null 表示没填。 */
export function isoToLocalDateTime(value) {
  if (value === null) return ''
  const date = new Date(value)
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16)
}
